import { IContractTemplateMutation } from 'services/templates/contract-template/types';
import { IContractTemplateForm } from 'services/templates/types';
import { separateTemplateTreeItems } from '../templateFormItemsSeparator';

export const contractTemplateFormToQuery = (
  form: IContractTemplateForm
): IContractTemplateMutation => {
  const {
    customSections,
    digitalDistribution,
    physicalDistribution,
    merchDistribution,
    channelDistribution,
  } = separateTemplateTreeItems(form.items[0].children);
  const { content } = form.items[0];

  return {
    title: `${content}`,
    digitalDistributionSection: digitalDistribution ?? null,
    customSections,
    physicalDistributionSection: physicalDistribution ?? null,
    merchDistributionSection: merchDistribution ?? null,
    channelDistributionSection: channelDistribution ?? null,
    version: form.version,
  };
};
